import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import NotFoundPage from '../NotFoundPage';
import "./styles/NewsDetailPage.css";
import { showFormatDate } from '../../utils/Utils';
import { TECHNICAL_URL } from '../../constants/Url';
import { Button, Card, Skeleton } from 'antd';
import httpClient from '../../utils/HttpClient';
import DynamicLayout from './components/DynamicLayout';
import ArticleAudioPlayer from '../../components/audio/ArticleAudioPlayer';
import { setTechnicalDetailAction } from '../../modules/dataWebsite/actions';
import PROModal from '../../components/PROModal';

export default function EductionDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMemberGateOpen, setIsMemberGateOpen] = useState(false);
  const data = useSelector((state) => state.dataWebsiteReducer?.technicalDetailData) || {
    coverimage: "",
    title: "",
    subtitle: "",
    category: "",
    createdAt: "",
  };

  const [notFound, setNotFound] = useState(false);
  const { code } = useParams();
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchData = async (targetCode) => {
    if (!targetCode) return;
    try {
      setLoading(true);

      const res = await httpClient.get(`${TECHNICAL_URL}/${targetCode}`)
        .then(res => res.data)
        .catch(error => ({ status: 500, message: error?.message }));

      if (res?.status === 200 && res?.data) {
        setNotFound(false);
        setTechnicalDetailAction({ ...res.data });
      } else {
        setNotFound(true);
      }
    } catch (error) {
      console.error("fetchData -> error", error);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (code) {
      fetchData(code);
    }
  }, [code]);

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/education');
    }
  };

  return (
    <div className='esi-std-container w-full'>
      <div className="pt-6 pb-2">
        <div 
          onClick={handleBack} 
          className="inline-flex items-center gap-2 cursor-pointer text-gray-500 hover:text-black transition-colors font-medium text-sm sm:text-base"
        >
          <ArrowLeftOutlined className="text-base" />
          <span>{t('text_back_previous_page')}</span>
        </div>
      </div>

      {
        loading && <div className='esi-std-white-space flex flex-col gap-3 w-full'>
          <Skeleton.Image rootClassName='news-image w-full' className='news-image' active={true} />
          <Skeleton.Input active block />
          <Skeleton.Input active block />
          <Skeleton.Input active block />
          <Skeleton.Input active block />
          <div className='flex items-center justify-between'>
            <Skeleton.Button className='news-primary-button' active shape={'default'} />

            <Skeleton.Input className="news-published-date" active />
          </div>

          <div className='flex flex-col gap-[4px]'>
            <Skeleton.Input active block />
            <Skeleton.Input active block />
            <Skeleton.Input active block />
          </div>
        </div>
      }

      {
        !loading && notFound ?
          <NotFoundPage />
          :
          <div style={{marginTop:"20px", marginBottom:"40px"}}>
          <Card className='card-reponsive' style={{margin:"auto"}}>
          <div className='esi-std-white-space flex flex-col px-3 md:px-6 gap-6'>
            {data.coverimage && <img className='news-image' src={data.coverimage} alt={data.title} />}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <h1 className='h1 flex-1 !mb-0'>{data && data.title}</h1>
              <ArticleAudioPlayer
                title={data?.title}
                subtitle={data?.subtitle}
                layouts={data?.layouts}
                content={data?.content}
              />
            </div>

            {data?.subtitle && <div className='news-summary'>{data.subtitle}</div>}

            <div className='flex items-center justify-between'>
              <Button className='news-primary-button'>{data && data.category}</Button>
              <div className='news-published-date'>{!_.isEmpty(data?.createdAt) && showFormatDate(data.createdAt)}</div>
            </div>

            <div className='flex flex-col gap-[4px]'>
              {
                data && data?.layouts?.map((item, idx) => <DynamicLayout key={idx} data={item} />)
              }
            </div>
          </div>
          </Card>
          </div>
      }

      <div className='esi-std-white-space'></div>
      <PROModal open={isMemberGateOpen} onCancel={() => setIsMemberGateOpen(false)} />
    </div>
  )
}
